// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2oFFd","footer":"ModalCreateQualiphyProcedure_footer__r-5kJ","additionData":"ModalCreateQualiphyProcedure_additionData__1NRfj"};